import type { SplitCopy } from "../content/index.js";

export interface StatementProps {
  readonly copy: SplitCopy;
  readonly tone?: "plain" | "sunken";
}

export function Statement({ copy, tone = "plain" }: StatementProps) {
  return (
    <section class={`section statement${tone === "sunken" ? " is-sunken" : ""}`}>
      <div class="wrap">
        <p class="micro">{copy.label}</p>
        <h2 class="section-title serif statement-title">{copy.title}</h2>
        <p class="statement-body">{copy.body}</p>
      </div>
    </section>
  );
}
